import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="info-page privacy">
      <Header />

      <div className="info-page__breadcrumb">
        <Link onClick={toTop} to="/">
          Home
        </Link>
        <span>/</span>
        <span>Privacy Policy</span>
      </div>

      <div className="info-page__content">
        <div className="info-page__main">
          <h1 className="info-page__title">Privacy Policy</h1>

          <p className="info-page__intro">Last updated: January 2024</p>

          <section className="info-section">
            <h2 className="info-section__title">Introduction</h2>
            <p>
              Petmorvanto Brands, Inc. ("Petmorvanto Brands," "we," "us," or
              "our") is committed to protecting your privacy. This Privacy
              Policy explains how we collect, use, disclose, and safeguard your
              information when you visit our website or make a purchase from us.
            </p>
            <p>
              Please read this Privacy Policy carefully. By accessing or using
              our services, you acknowledge that you have read, understood, and
              agree to be bound by all the terms of this Privacy Policy.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Information We Collect</h2>
            <p>
              We collect information that you provide directly to us, including:
            </p>
            <ul className="info-list">
              <li>
                Name, email address, phone number, and shipping address when you
                create an account or place an order
              </li>
              <li>
                Payment information (credit card numbers, PayPal account) for
                processing transactions
              </li>
              <li>Demographic information such as preferences and interests</li>
              <li>
                Communication preferences and any other information you choose
                to provide
              </li>
            </ul>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="info-list">
              <li>
                Process and fulfill your orders, including sending shipping
                notifications
              </li>
              <li>
                Send promotional communications (you can opt-out at any time)
              </li>
              <li>Improve our website and services based on your feedback</li>
              <li>
                Respond to your questions, comments, and customer service
                requests
              </li>
              <li>Display relevant advertisements based on your interests</li>
            </ul>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Information Sharing</h2>
            <p>
              We do not sell your personal information. We may share your
              information with:
            </p>
            <ul className="info-list">
              <li>
                Service providers who assist in operating our website and
                processing orders
              </li>
              <li>
                Legal authorities when required by law or to protect our rights
              </li>
              <li>
                Business partners with your explicit consent for joint
                promotions
              </li>
            </ul>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">
              Cookies and Tracking Technologies
            </h2>
            <p>
              We use cookies and similar tracking technologies to enhance your
              browsing experience, analyze site traffic, and personalize
              content. You can control cookies through your browser settings.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Data Security</h2>
            <p>
              We implement appropriate security measures to protect your
              personal information from unauthorized access, alteration,
              disclosure, or destruction. However, no method of transmission
              over the Internet is 100% secure.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Your Rights</h2>
            <p>
              Depending on your location, you may have the right to access,
              correct, or delete your personal information. You may also opt out
              of marketing communications at any time by clicking the
              unsubscribe link in our emails.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Children's Privacy</h2>
            <p>
              Our website is not intended for children under 13 years of age. We
              do not knowingly collect personal information from children under
              13.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new policy on this page
              and updating the "Last updated" date.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us at:
            </p>
            <div className="contact-block">
              <p>9750 Royal Lane Dallas, TX 75231 United States</p>
              <p>split@petmorvanto.club</p>
            </div>
          </section>
        </div>

        <aside className="info-page__sidebar">
          <div className="sidebar-card">
            <h3 className="sidebar-card__title">Quick Links</h3>
            <ul className="sidebar-links">
              <li>
                <Link to="/terms" onClick={toTop}>
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/returns" onClick={toTop}>
                  Return Policy
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </aside>
      </div>

      <Footer />
    </div>
  );
}

export default Privacy;
